import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppErrors, NotFoundError } from '@fitness-force/errors';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { CancelClientSubscriptionFreezeRequest, ClientSubscriptionFreezeResponse, CreateClientSubscriptionFreezeRequest, GetClientSubscriptionResponse, PaymentTimeline, StopClientSubscriptionFreezeRequest, UpdateClientSubscriptionFreezeRequest } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FreezeService {
  BASE_URL: string = environment.BASE_URL;

  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  GetSubscriptionByClientId(tenantId: number, clientId: number): Observable<GetClientSubscriptionResponse[]> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.FREEZE.GET_AVAILABLEFORFREEZE.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString());
    return this.getRequest(url);
  }

  GetFreezeByClientId(tenantId: number, clientId: number): Observable<ClientSubscriptionFreezeResponse[]> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.FREEZE.GET_FREEZEBYCLIENTID.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString());
    return this.getRequest(url);
  }

  GetFreezeBySubscriptionId(tenantId: number, clientId: number, subscriptionId: number): Observable<ClientSubscriptionFreezeResponse[]> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.FREEZE.GET_FREEZEBYSUBSCRIPTIONID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{clt_subs_id}', subscriptionId.toString());

    return this.getRequest(url);
  }

  GetFreezeTimeline(clientId: number, subscriptionId: number): Observable<PaymentTimeline> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.FREEZE.GET_FREEZETIMELINE
      .replace('{client_id}', clientId.toString())
      .replace('{clt_subs_id}', subscriptionId.toString());

    return this.getRequest(url);
  }

  PostCreateFreeze(tenantId: number, clientId: number, subscriptionId: number, obj: CreateClientSubscriptionFreezeRequest): Observable<number> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.FREEZE.POST_CREATEFREEZE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{clt_subs_id}', subscriptionId.toString());

    return this.postRequest(url, obj);
  }

  PostCancelFreeze(BASE_URL: string, tenantId: number, clientId: number, subscriptionId: number, freezeId: number, obj: CancelClientSubscriptionFreezeRequest): Observable<number> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.FREEZE.POST_CANCELFREEZE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{clt_subs_id}', subscriptionId.toString())
      .replace('{clt_subfreeze_id}', freezeId.toString());

    return this.postRequest(url, obj);
  }

  PostStopFreeze(BASE_URL: string, tenantId: number, clientId: number, subscriptionId: number, freezeId: number, obj: StopClientSubscriptionFreezeRequest): Observable<number> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.FREEZE.POST_STOPFREEZE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{clt_subs_id}', subscriptionId.toString())
      .replace('{clt_subfreeze_id}', freezeId.toString());

    return this.postRequest(url, obj);
  }

  PutUpdateFreeze(tenantId: number, clientId: number, subscriptionId: number, freezeId: number, obj: UpdateClientSubscriptionFreezeRequest): Observable<number> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.FREEZE.PUT_UPDATEFREEZE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{clt_subs_id}', subscriptionId.toString())
      .replace('{clt_subfreeze_id}', freezeId.toString());

    return this.putRequest(url, obj);
  }

  /* Common Method */
  putRequest(url: string, body: any) {
    return this.http.put(url, body, this.httpOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  postRequest(url: string, body: any) {
    return this.http.post(url, body, this.httpOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getRequest(url: string) {
    return this.http.get(url, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }
  /* Common Method */
}